//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { directive } from 'vue-awesome-swiper'
import 'swiper/swiper.scss'
export default {
  name: 'Slider',
  directives: {
    swiper: directive
  },
  data () {
    return {
      links: [],
      banners: [],
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 15,
        slidesPerGroup: 1,
        autoplay: {
          delay: 10000
        },
        draggable: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          991: {
            slidesPerView: 1
          },
          767: {
            slidesPerView: 1
          },
          320: {
            slidesPerView: 1
          }
        }
      }
    }
  },
  created () {
    this.$store.dispatch('axios/get', { url: '/application/slider', config: { baseURL: process.env.BASE_URL } })
      .then((r) => {
        r.data.data.sliders.sort((a, b) => {
          return a.order - b.order
        })
        this.banners = r.data.data.sliders.map(i => i.image)
        this.links = r.data.data.sliders.map(i => i.url)
      })
  }
}
